
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { takeSsoReturnPath } from './init-keycloak';
import { useAuthStore } from './auth-store';

export function useSsoReturnPath(): void {
  const navigate = useNavigate();
  useEffect(() => {
    if (!useAuthStore.getState().isAuthenticated) return;
    const to = takeSsoReturnPath();
    if (to) navigate(to, { replace: true });
  }, [navigate]);
}
